import React, { Component, ReactElement } from 'react'
import { LanguageContextProvider } from '../../React/Common/Contexts'
import { Route } from '../Annotation/Route'
import { RouteID } from '../Components/Molecules/Header/Types/Types'
import { RouteGuard } from '../Guards/RouteGuard'
import { Messages } from '../Components/Organisms/Messages/Messages'

/**
 * Routed Messages page.
 */
@Route(RouteID.MESSAGES)
export class MessagesPage extends Component {
    /**
     * Renders the guarded routed page.
     *
     * @returns Messages page component tree.
     */
    render(): ReactElement {
        return (
            <RouteGuard route={RouteID.MESSAGES}>
                <LanguageContextProvider>
                    <Messages />
                </LanguageContextProvider>
            </RouteGuard>
        )
    }
}
